import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import {Objects, Collections} from "components";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import UserRoles from "constants/UserRoles";
import {Button} from "reactstrap";

const breadcrumbsStatic = [{
	name: 'Scores',
	url: '/scores',
	icon: 'users',
}];

export default class ScoresManager extends Framework.Components.View {

	constructor(props) {
		super(props, 'phonelogsamount-3');
	}

	render() {
		let {match, history, baseUrl, roles} = this.props;
		let {name} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: 'Scores Manager',
				url: `/scores/manager`,
				icon: 'users',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}>
					<Button data-id="add-user" onClick={this.toggle('modalMetricAdd')} size="sm" color="primary">
						<i className="fa fa-user"/>&nbsp;&nbsp;Add Metric
					</Button>
				</Framework.Components.PageBar>

				<Framework.Elements.UniversalModal
					name={"Metric"}
					object={Objects.ScorePart}
					history={this.props.history}
					toggle={this.state.modalMetricAdd}
					reportClose={this.reportClose('modalMetricAdd')}
					afterSave={() => this.setState({refresh: !this.state.refresh})}
					reloadPage={this.refreshPage}
					objectProps={{name: window.location.href.split('-')[1]}}
				/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Phone Logs Amount" value="phonelogsamount-3"/>
					<Tab label="Book Types Count" value="bookcount-4"/>
					<Tab label="Phone Logs Notes" value="phonelogsnotes-5"/>
					<Tab label="Calendar Notes" value="calendarnotes-6"/>
					<Tab label="Time Between Events" value="tbe-7"/>
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'phonelogsamount-3'})}>
					<Collections.ScoreName
						id={3}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'bookcount-4'})}>
					<Collections.ScoreName
						id={4}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'phonelogsnotes-5'})}>
					<Collections.ScoreName
						id={5}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'calendarnotes-6'})}>
					<Collections.ScoreName
						id={6}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'tbe-7'})}>
					<Collections.ScoreName
						id={7}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
			</div>
		)
	}
}
